import { render, staticRenderFns } from "./ShopArticleSearchBarComponent.vue?vue&type=template&id=db3a5336&scoped=true"
import script from "./ShopArticleSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./ShopArticleSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./ShopArticleSearchBarComponent.vue?vue&type=style&index=0&id=db3a5336&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3a5336",
  null
  
)

export default component.exports